import React from 'react';
import { ComparisonCards } from './comparison-cards';

const options = [
  {
    title: "Do It Yourself",
    money: "$0 upfront, hidden cost = your time",
    time: "Nights & weekends lost",
    quality: "100% yours, 100% bottleneck",
    speed: "One channel at best",
    risk: "Burnout, inconsistent posting"
  },
  {
    title: "Hire a Manager / Agency",
    money: "$2-5K/mo retainer",
    time: "On-boarding + endless approvals",
    quality: "Expertise varies, often templates",
    speed: "Depends on headcount",
    risk: "Turnover, NDA headaches"
  },
  {
    title: "Automate with Serge",
    money: "Flat $X/mo",
    time: "10 min per week",
    quality: "Your voice + AI A/B tests",
    speed: "One click → all channels",
    risk: "Cancel anytime, data stays yours",
    recommended: true
  }
];

export function ComparisonDemo() {
  return (
    <div className="w-full py-8 px-4 overflow-hidden">
      <ComparisonCards options={options} />
    </div>
  );
}